import moment from 'moment';
import get from 'lodash/get';

import { USER_TYPES } from '../../auth/constants';

export const appointmentBookedBy = (appointment) => {
  let bookedBy = 'Unknown';
  switch (get(appointment, 'bookedBy.kind')) {
    case USER_TYPES.customer:
      bookedBy = `Customer - ${appointment.platform}`;
      break;
    case USER_TYPES.barber:
      bookedBy = `Barber - ${appointment.platform}`;
      break;
    case USER_TYPES.shop:
      bookedBy = `Shop - ${appointment.platform}`;
      break;
    case USER_TYPES.admin:
    case USER_TYPES.regularAdmin:
      bookedBy = `Admin - ${appointment.platform}`;
      break;
    case USER_TYPES.agent:
      bookedBy = `Agent - ${appointment.platform}`;
      break;
    default:
      bookedBy = `Unknown - ${appointment.platform}`;
  }

  if (appointment.bookedFromWaitingList) {
    bookedBy = 'Customer - Waiting list';
  }

  return bookedBy;
};

export const appointmentStatus = (appointment) => {
  let status = 'Unknown';
  if (appointment.status === 1) {
    status = 'Canceled';
  } else if (appointment.noShow) {
    status = 'No Show';
  } else if (moment.utc().isBefore(appointment.start)) {
    status = 'Upcoming';
  } /* if (appointment.status === 2) */ else {
    status = 'Completed';
  }
  return status;
};

const labels = {
  reader: 'POS',
  card: 'POS',
  gift_card: 'Gift Card',
  cash: 'Cash/Other',
  stripe: 'Via Squire',
};

export const appointmentPayment = (appointment) => {
  if (!get(appointment, 'payment.successful')) {
    return 'Unpaid';
  }
  return get(appointment, 'payment.paymentTypes', [])
    .map((type) => labels[type])
    .join(', ');
};

export const appointmentDiscountRefund = (appointment) =>
  get(appointment, 'discount.amount', 0) + get(appointment, 'refunds[0].refundAmount', 0) + appointment.promoAmount;

export const getTodayLocal = (timezone) => moment.tz(timezone).startOf('day').toDate();

export const sortCurrencyFunction = (a, b) => {
  const first = Number(a.replace(/[^\d.,]/g, ''));
  const second = Number(b.replace(/[^\d.,]/g, ''));

  return first > second ? 1 : -1;
};
